export const environment = {

    baseUrl: 'https://amaplan-dev.amazone.de/api',

    googleMapsApiKey: "AIzaSyDzCS5rTsLsG95wLtfxRHGDslMMAniaDeE",

    // Url of the Identity Provider
    issuer: 'https://login-stage.amazone.de/cas/oidc',

    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin + '',

    // The SPA's id. The SPA is registerd with this id at the auth-server
    // clientId: 'server.code',
    clientId: 'D7nR7s26UrSvpxa79ydt',



    // Just needed if your auth server demands a secret. In general, this
    // is a sign that the auth server is not configured with SPAs in mind
    // and it might not enforce further best practices vital for security
    // such applications.
    clientSecret: 'j5YnLYZL8vgsiyq5gD87gLQbqg942q',

    responseType: 'code',

    // set the scope for the permissions the client should request
    // The first four are defined by OIDC.
    // Important: Request offline_access to get a refresh token
    // The api scope is a usecase specific one
    //scope: 'openid profile email offline_access api',
    scope: 'openid profile offline_access D7nR7s26UrSvpxa79ydt',

    showDebugInformation: true,

};
